(() => {
  const COLLECTION_HANDLE = 'todos-los-productos';
  const LEGACY_LINK_SELECTOR = 'a[href*="/collections/all"]';

  const localizedCatalogPath = () => {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    return `${normalizedRoot}collections/${COLLECTION_HANDLE}`.replace(/\/+/g, '/');
  };

  const isLegacyCatalogPath = (pathname) => {
    const normalized = pathname.replace(/\/+$/, '') || '/';
    return normalized === '/collections/all' || /^\/[a-z]{2}(?:-[a-z]{2})?\/collections\/all$/i.test(normalized);
  };

  const rewriteAnchor = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (!anchor.getAttribute('href')?.includes('/collections/all')) return;

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch {
      return;
    }
    if (url.origin !== window.location.origin || !isLegacyCatalogPath(url.pathname)) return;

    anchor.href = `${localizedCatalogPath()}${url.search}${url.hash}`;
    anchor.dataset.mblCatalogDestination = 'tiktok-ranked';
  };

  const rewriteInteraction = (event) => {
    const target = event.target;
    if (target instanceof Element) rewriteAnchor(target.closest('a[href]'));
  };

  for (const type of ['pointerdown', 'focusin', 'click', 'auxclick', 'contextmenu', 'dragstart']) {
    document.addEventListener(type, rewriteInteraction, { capture: true, passive: true });
  }

  const initialize = () => {
    const rewriteInitialLinks = () => document.querySelectorAll(LEGACY_LINK_SELECTOR).forEach(rewriteAnchor);
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(rewriteInitialLinks, { timeout: 1200 });
    } else {
      window.setTimeout(rewriteInitialLinks, 50);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
